import { i18n } from '@fishx/i18n';
import { message } from '@whalecloud/fdx';
import { getRequestData, emptyObj } from '@/utils';
import { createCustomerBsnl } from '@/pages/NewConnection/services';

export default {
  namespace: 'customerInfo',
  state: {
    attrObj: {},
    certTypeList: [],
    stateAddrOpts: [],
    districtOpts: [],
    mainLocalityOpts: [],
    subLocalityOpts: [],
    occupationList: [],
    custAddressId: '',
    custValueMap: {}, // 已存在客户的相关信息
    custCertValue: {}, // 已存在客户证件信息
    custContactMan: {}, // 已存在客户联系人信息
    custAddrList: [], // 已存在客户地址信息
    custAddrInfo: {},
    poaDefaultFileList: [],
    poiDefaultFileList: [],
    customerInfo: {},
  },
  effects: {
    * createCustomerBsnl({ payload }, { call, put }) {
      const createCustResponse = yield call(createCustomerBsnl, payload);
      const { custCode, custId } = getRequestData(createCustResponse);
      if (custId) {
        message.success(i18n('BUSINESS_CREATE_CUSTOMER_SUCCESSFULLY'));
      }
      yield put({
        type: 'save',
        payload: { custId, custCode },
      });
      return { custCode, custId };
    },
    * clear(_, { select, put }) {
      const obj = yield select(state => state.customerInfo);
      yield put({
        type: 'save',
        payload: { ...emptyObj(obj) },
      });
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
